<template>
  <div
    :style="{width, height, maxWidth, maxHeight}"
    :class="[(type == 'appIcon' && !show) && 'app-icon']"
  >
    <el-image
      :src="src"
      :alt="alt"
      :lazy="lazy"
      scroll-container="#web-003-home-content .web-003-scrollbar>.el-scrollbar__wrap"
      :style="{width, height, maxWidth, maxHeight}"
      :class="['web-img', show && 'show', isTween && 'tween']"
      :fit="fit"
      @load="onLoad"
      @error="onError"
    >
      <div
        slot="error"
        :class="['image-slot', type == 'appIcon' && 'app-icon']"
        :style="{width, height, maxWidth, maxHeight}"
      >
        <!--      <i class="el-icon-picture-outline" />-->
      </div>
    </el-image>
  </div>
</template>

<script>
export default {
    name: 'WebImg',
    props: {
        src: {
            type: String,
            default: '',
        },
        alt: {
            type: String,
            default: '',
        },
        lazy: {
            type: Boolean,
            default: true,
        },
        /*
        fill: 默认值。内容拉伸填满整个content box, 不保证保持原有的比例。
        contain: 保持原有尺寸比例。长度和高度中短的那条边跟容器大小一致，长的那条等比缩放，可能会有留白。
        cover: 保持原有尺寸比例。宽度和高度中长的那条边跟容器大小一致，短的那条等比缩放。可能会有部分区域不可见。
        none: 保持原有尺寸比例。同时保持替换内容原始尺寸大小。
        scale-down:保持原有尺寸比例,如果容器尺寸大于图片内容尺寸，保持图片的原有尺寸，不会放大失真；容器尺寸小于图片内容尺寸，用法跟contain一样。
        */
        fit: {
            type: String,
            default: 'fill',
        },
        width: {
            type: String,
            default: 'unset',
        },
        height: {
            type: String,
            default: 'unset',
        },
        maxWidth: {
            type: String,
            default: 'unset',
        },
        maxHeight: {
            type: String,
            default: 'unset',
        },
        type: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            show: false,
            loadError: false,
        };
    },
    computed: {
        isTween () {
            return this.type !== 'appIcon' || (this.type === 'appIcon' && !this.loadError);
        },
    },
    methods: {
        onLoad () {
            this.$nextTick(() => {
                this.show = true;
            });
        },
        onError () {
            this.$emit('error');
            this.$nextTick(() => {
                this.show = true;
                this.loadError = true;
            });
        },

    },
};
</script>

<style scoped lang="scss">
.app-icon {
    background-image: url("../../../../../assets/image/icon_log_management_small.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80px;
}
.web-img {
    opacity: 0;
    &.tween {
        transition: opacity 0.3s;
    }
    &.show {
        opacity: 1;
    }
    ::v-deep .image-slot {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #EAF1FD;
        background-image: url("../../../../../assets/image/img.png");
        background-position: center;
        background-repeat: no-repeat;
        img {
            object-fit: contain;
        }
        &.app-icon {
            background-color: transparent;
            background-image: url("../../../../../assets/image/icon_log_management_small.png");
            background-position: center;
            background-repeat: no-repeat;
            background-size: 80px;
        }
    }
}
</style>
